export default "__VITE_ASSET__C5vjxY$D__"